import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";

// 부티크가 오더를 운송 중으로 바꾸면서 배송사·송장번호로 운송/통관 건을 만든다.
// 서버가 운송을 만들고 그 오더(와 오더시트)를 운송 중으로 바꾼 뒤 오더시트세트 상세를 돌려준다.
export interface RegisterBoutiqueShipmentRequest {
  carrierName: string;
  trackingNumber: string;
}

export interface RegisterBoutiqueShipmentResponse extends LightOrderSheetSet {}

export interface RegisterBoutiqueShipmentPathParameter {
  boutiqueId: number;
  orderSheetSetId: number;
}

export const registerBoutiqueShipmentTemplateUrl =
  "/boutiques/:boutiqueId/order-sheet-sets/:orderSheetSetId/transportations";

export const registerBoutiqueShipmentKey: YWRKey<RegisterBoutiqueShipmentPathParameter> =
  {
    url: (parameter) => {
      return calcUrl(registerBoutiqueShipmentTemplateUrl, parameter);
    },
    method: "post",
  };

export default function useRegisterBoutiqueShipment() {
  const fetcher = useFetcher<
    RegisterBoutiqueShipmentRequest,
    RegisterBoutiqueShipmentResponse
  >();

  return useYWR(registerBoutiqueShipmentKey, fetcher);
}
